import { Box, List, ListItem, Typography } from "@mui/material";
import { useRef } from "react";

interface messageData {
  content: string;
  role: string;
}

interface MessageViewContainerProps {
  conversationData: messageData[];
  bottomRef: React.RefObject<HTMLDivElement | null>;
}

export const MessageViewContainer: React.FC<MessageViewContainerProps> = ({
  conversationData,
  bottomRef,
}) => {
  const messageListRef = useRef<HTMLUListElement>(null);

  return (
    <List
      ref={messageListRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end", // メッセージを下端に配置
        minHeight: "100%", // 親要素の高さを使い切る
        overflowY: "auto",
        px: 0.5,
        py: 0.5,
        margin: 0, // デフォルトのmarginを削除
        padding: 0.5, // paddingを統一
      }}
    >
      {conversationData.map((msg, idx) => (
        <ListItem
          key={idx}
          sx={{
            justifyContent: msg.role === "user" ? "flex-end" : "flex-start",
            py: 0.4,
            px: 0,
          }}
        >
          {msg.role === "assistant" && (
            <img
              src="/img/capital_bot.png"
              alt="Capital Bot"
              style={{
                width: "40px",
                height: "40px",
                maxWidth: "50%",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          )}
          <Box
            sx={{
              display: "inline-block",
              maxWidth: "80%",
              backgroundColor: msg.role === "user" ? "#e0f7fa" : "#f0f0f0",
              borderRadius: 4,
              px: 1.5,
              py: 1,
              whiteSpace: "pre-wrap", // テキストの折り返しを有効にする
              overflowWrap: "break-word", // 単語を途中で折り返す
            }}
          >
            {/* {idx === conversationData.length && <div ref={bottomRef} />} */}
            <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
              {msg.content}
            </Typography>
          </Box>
        </ListItem>
      ))}
      <div ref={bottomRef} />
    </List>
  );
};
